import Image from "next/image"
import { trackGASocialClick } from "services/analytics"
import { trackFbq } from "services/tracking"

import { Links } from "config/links"

import { Box } from "components/shared/box"
import { Button } from "components/shared/landing/button"
import { Link } from "components/shared/link"
// import { Link } from "components/shared/link"
import { Text } from "components/shared/text"

export function BottomSection() {
  return (
    <Box className="pt-10">
      <Box row className="justify-center gap-4">
        <Text
          weight="bold"
          className="uppercase text-h2 lg:text-[100px] lg:leading-[100px] text-transparent [-webkit-text-stroke:4px_white]"
        >
          Don’t
        </Text>
        <Text weight="bold" className="uppercase text-h2 lg:text-[100px] lg:leading-[100px]">
          miss out
        </Text>
      </Box>
      <Box center className="relative -mt-5 lg:-mt-12">
        <Box className="absolute z-0 -bottom-[400px] left-[calc(50%-500px)] bg-[#FF46AA] lg:w-[1000px] lg:h-[1000px] rounded-full blur-[140px] opacity-30" />
        <Box center className="max-w-[2800px]">
          <Image src="/images/pages/bot-3d/bottom-section/bots.png" alt="bots" width={2946} height={1166} />
        </Box>
        <Box className="absolute z-0 -bottom-[250px] left-[calc(50%-300px)] bg-[#FF46AA] lg:w-[600px] lg:h-[600px] rounded-full blur-[100px] opacity-50" />
        <Box className="absolute z-1 bottom-0 justify-center pb-10">
          <Box className="w-[300px] lg:w-[auto] shadow-lg">
            <Link
              href={Links.DISCORD}
              target="_blank"
              withRedirect
              onClick={() => {
                trackFbq("track", "Lead")
                trackGASocialClick("discord", "onpage")
              }}
            >
              <Button className="w-full md:w-auto" size="lg">
                Join our discord
              </Button>
            </Link>
            {/* <Text center>
              Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
              consequat.
            </Text> */}
          </Box>
        </Box>
      </Box>
      {/* <Box row center className="p-10 text-white gap-8 z-1">
        <Link>Companions</Link>
        <Link>Privacy</Link>
        <Link>Disclamer</Link>
        <Link>Cookies</Link>
        <Link>Contact us</Link>
      </Box> */}
    </Box>
  )
}
